export default "__VITE_PUBLIC_ASSET__66e550c9__"